import { render, staticRenderFns } from "./VDashboard.vue?vue&type=template&id=9b7a7e86&"
import script from "./VDashboard.vue?vue&type=script&lang=js&"
export * from "./VDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports